export * from './svg-icon.component';
